import React, { useEffect } from "react";
import { LayerGroup, TileLayer, useMap } from "react-leaflet";
import { useSelector } from 'react-redux';
import { LayerAddress } from "./LayerAddress";
import { LayerPillars } from "./LayerPillars";
import { LayerTransformers } from "./LayerTransformers";
import { LayerFeedingSubstations } from "./LayerFeedingSubstations";
import { LayerFider330 } from "./LayerFider330";
import { LayerFiders } from "./LayerFiders";
import { LayerFider35 } from "./LayerFider35";
import { LayerFider110 } from "./LayerFider110";
import { LayerPowerPlants } from "./LayerPowerPlants";
// import { LayerRes } from "./LayerRes";
import { LayerRes } from "./LayerResGradient";
import { LayerPillarsOpn } from "./LayerPillarsOpn";
import { LayerPillarsZvz } from "./LayerPillarsZvz";
import { LayerPillarsRunn } from "./LayerPillarsRunn";
import { LayerPillarsRlnd } from "./LayerPillarsRlnd";
import { LayerPlan } from "./LayerPlan";
import { LayerTasks } from "./LayerTasks";
import YandexMutantLayer from "./YandexMutantLayer";



const layersUrl = {
    twogis: "https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1.1",
    osm: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    arc: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    google: 'https://mt1.google.com/vt/lyrs=m@169000000&hl=ru&x={x}&y={y}&z={z}',
    yandex: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=21.06.04-0-b210520094930&x={x}&y={y}&z={z}&scale=1&lang=ru',
    gurtam: 'https://gps.vrplus.ru/gis_vector/{x}_{y}_{z}/4700/tile.pbf',
    googleSatellite: 'https://mt1.google.com/vt/lyrs=s@169000000&hl=ru&x={x}&y={y}&z={z}',
    googleHybrid: 'https://mt1.google.com/vt/lyrs=s,h@169000000&hl=ru&x={x}&y={y}&z={z}',
    yandexSatellite: 'https://core-sat.maps.yandex.net/tiles?l=sat&v=3.787.0&x=82802&y=48273&z=17&lang=ru',
    twogisSatellite: 'http://tile1.maps.2gis.com/tiles?x={x}&y={y}&z={z}',
    bindSatellite: 'http://ecn.t3.tiles.virtualearth.net/tiles/a{q}.jpeg?g=0&dir=dir_n'


}

const baseLayers = {
    1: { name: 'Карта(OSM)', url: layersUrl.osm, maxNativeZoom: 20, type: 'tile' },
    2: { name: 'Карта(2GIS)', url: layersUrl.twogis, maxNativeZoom: 16, type: 'tile' },
    3: { name: 'Карта(Yandex)', type: 'yandex', yandexType: 'yandex#map' },
    4: { name: 'Спутник(Yandex)', type: 'yandex', yandexType: 'yandex#satellite' },
    5: { name: 'Гибрид(Yandex)', type: 'yandex', yandexType: 'yandex#hybrid' },
    6: { name: 'Карта(Google)', url: layersUrl.google, maxNativeZoom: 18, type: 'tile' },
    7: { name: 'Спутник(Google)', url: layersUrl.googleSatellite, type: 'tile' },
    8: { name: 'Гибрид(Google")', url: layersUrl.googleHybrid, type: 'tile' },
    9: { name: 'Белый фон', url: layersUrl.osm, type: 'tile' },
}



const ControlLayer = () => {
    const map = useMap()
    const { baseLayer, overlayLayers, dataLayers, settings } = useSelector(state => state.helper.layers)

    
    const applyFilters = () => {
        const { brightness, contrast, saturation, opacity } = settings || { brightness: 100, contrast: 100, saturation: 100, opacity: 100 };
        const filterValue = `brightness(${brightness}%) contrast(${contrast}%) saturate(${saturation}%) opacity(${opacity}%)`;
        // // Ищем YandexMutantLayer контейнер
        const yandexContainer = map.getContainer().querySelector('.leaflet-yandex-mutant');
        if (yandexContainer) {
            yandexContainer.style.filter = filterValue;
            return
        }
        const tilePane = map.getContainer().querySelector('.leaflet-tile-pane');
        if (tilePane) {
            tilePane.style.filter = filterValue
            return
        }

    };

    useEffect(() => {
        applyFilters()
    }, [map])

    return (
        <>
            {/* Базовый слой */}
            {baseLayer !== 9 && baseLayers[baseLayer] && (
                <>
                    {baseLayers[baseLayer].type === 'tile' && (
                        <TileLayer
                            url={baseLayers[baseLayer].url}
                            keepBuffer={3}
                            key={baseLayer} // Принудительное обновление при смене слоя
                            maxZoom={20}
                            maxNativeZoom={baseLayers[baseLayer].maxNativeZoom || 18}
                            
                        />
                    )}
                    {baseLayers[baseLayer].type === 'yandex' && (
                        <YandexMutantLayer
                            type={baseLayers[baseLayer].yandexType}
                            opacity={1}
                            traffic={false}
                            key={baseLayer}
                        />
                    )}
                </>
            )}

            {/* Overlay слои */}
            

            {overlayLayers.powerPlants && (
                <LayerGroup>
                    <LayerPowerPlants />
                </LayerGroup>
            )}

            {overlayLayers.feedingSubstations && (
                <LayerGroup>
                    <LayerFeedingSubstations />
                </LayerGroup>
            )}



           {overlayLayers.fider330 && (
                <LayerGroup>
                    <LayerFider330 />
                </LayerGroup>
            )}

            {overlayLayers.fider110 && (
                <LayerGroup>
                    <LayerFider110 />
                </LayerGroup>
            )}

            {overlayLayers.fider35 && (
                <LayerGroup>
                    <LayerFider35 />
                </LayerGroup>
            )}
             {overlayLayers.fider10 && (
                <LayerGroup>
                    <LayerFiders class="fider10" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} viewNotSipClass={dataLayers.viewNotSipClass}  viewStagesBackLight={dataLayers.viewStagesBackLight}/>
                </LayerGroup>
            )}
            {overlayLayers.fider10_04 && (
                <LayerGroup>
                    <LayerFiders class="fider10-04" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} viewNotSipClass={dataLayers.viewNotSipClass} viewStagesBackLight={dataLayers.viewStagesBackLight} />
                </LayerGroup>
            )}
            {overlayLayers.fider6 && (
                <LayerGroup>
                    <LayerFiders class="fider6" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} viewNotSipClass={dataLayers.viewNotSipClass} viewStagesBackLight={dataLayers.viewStagesBackLight} />
                </LayerGroup>
            )}
            {overlayLayers.fider04 && (
                <LayerGroup>
                    <LayerFiders class="fider04" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} viewNotSipClass={dataLayers.viewNotSipClass} viewStagesBackLight={dataLayers.viewStagesBackLight} />
                </LayerGroup>
            )}






            {overlayLayers.opn && (
                <LayerGroup>
                    <LayerPillarsOpn viewMounted={dataLayers.viewMounted} />
                </LayerGroup>
            )}
            {overlayLayers.zvz && (
                <LayerGroup>
                    <LayerPillarsZvz viewMounted={dataLayers.viewMounted} />
                </LayerGroup>
            )}
            {overlayLayers.rlnd && (
                <LayerGroup>
                    <LayerPillarsRlnd viewMounted={dataLayers.viewMounted} />
                </LayerGroup>
            )}
            {overlayLayers.runn && (
                <LayerGroup>
                    <LayerPillarsRunn  viewMounted={dataLayers.viewMounted}/>
                </LayerGroup>
            )}


            {overlayLayers.pillar10 && (
                <LayerGroup>
                    <LayerPillars class="pillar10" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} />
                </LayerGroup>
            )}
            {overlayLayers.pillar04 && (
                <LayerGroup>
                    <LayerPillars class="pillar04" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} viewTasks={dataLayers.viewTasks} />
                </LayerGroup>
            )}
            {overlayLayers.pillar04_10 && (
                <LayerGroup>
                    <LayerPillars class="pillar04-10" viewProjectStatus={dataLayers.viewProjectStatus} viewMounted={dataLayers.viewMounted} viewTasks={dataLayers.viewTasks} />
                </LayerGroup>
            )}

            {overlayLayers.transformers && (
                <LayerGroup>
                    <LayerTransformers viewProjectStatus={true}  viewMounted={dataLayers.viewMounted}/>
                </LayerGroup>
            )}

            {dataLayers.viewPlan && (
                <LayerGroup>
                    <LayerPlan />
                </LayerGroup>
            )}

            {dataLayers.viewTasks && (
                <LayerGroup>
                    <LayerTasks statuses={Object.entries(dataLayers).filter(([layer, enabled]) => enabled && layer.startsWith('tasks:')).map(([layer, enabled]) => layer.split(':')[1])} />
                </LayerGroup>
            )}

            <LayerGroup>
                <LayerAddress />
            </LayerGroup>

            {overlayLayers.res && (
                <LayerGroup>
                    <LayerRes />
                </LayerGroup>
            )}


        </>
    )

    
};

export default ControlLayer;
